import { useNavigate } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import useUserSceneStore from '../store/useUserSceneStore'

function UserSceneNotification() {
  const navigate = useNavigate()
  const { userScene, isDetecting } = useUserSceneStore()

  if (isDetecting || !userScene) {
    return null
  }

  const handlePrimaryAction = () => {
    switch (userScene) {
      case 'NEW_USER':
        navigate('/mirror/factory')
        break
      case 'MIRROR_USER':
        navigate('/mirror/editor')
        break
      case 'ESTABLISHED_USER':
        navigate('/content/publish')
        break
      default:
        break
    }
  }

  const handleSecondaryAction = () => {
    switch (userScene) {
      case 'NEW_USER':
        navigate('/mirror/source')
        break
      case 'MIRROR_USER':
        navigate('/mirror/source')
        break
      case 'ESTABLISHED_USER':
        navigate('/analytics/heatmap')
        break
      default:
        break
    }
  }

  const getSceneGuidance = (scene) => {
    const guidanceMap = {
      NEW_USER: {
        title: '欢迎使用 Mirror-X',
        description: '检测到当前站点未部署内容，建议先完成模板部署。',
        primaryAction: '前往模板工厂',
        secondaryAction: '重新检测域名',
        icon: '✨',
        color: 'blue',
      },
      MIRROR_USER: {
        title: '检测到已有站点内容',
        description: '可以直接进入镜像改写流程。',
        primaryAction: '开始镜像改写',
        secondaryAction: '查看检测结果',
        icon: '🪞',
        color: 'green',
      },
      ESTABLISHED_USER: {
        title: '欢迎回来',
        description: '继续进行内容管理与运营。',
        primaryAction: '进入发布中心',
        secondaryAction: '查看分析',
        icon: '📈',
        color: 'purple',
      },
    }
    return guidanceMap[scene] || guidanceMap.NEW_USER
  }

  const guidance = getSceneGuidance(userScene)

  if (userScene === 'ESTABLISHED_USER') {
    return null
  }

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-50 border-blue-200 text-blue-800',
      green: 'bg-green-50 border-green-200 text-green-800',
      purple: 'bg-purple-50 border-purple-200 text-purple-800',
    }
    return colorMap[color] || colorMap.blue
  }

  const getButtonColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-600 hover:bg-blue-700 text-white',
      green: 'bg-green-600 hover:bg-green-700 text-white',
      purple: 'bg-purple-600 hover:bg-purple-700 text-white',
    }
    return colorMap[color] || colorMap.blue
  }

  return (
    <div className={`${getColorClasses(guidance.color)} border rounded-lg p-6 shadow-lg mb-6 animate-fade-in`}>
      <div className="flex items-start gap-4">
        <div className="text-2xl flex-shrink-0 mt-0.5">{guidance.icon}</div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold">{guidance.title}</h3>
          <p className="text-sm mt-2">{guidance.description}</p>
          <div className="mt-4 flex gap-3 justify-end">
            <button
              onClick={handleSecondaryAction}
              className="inline-flex items-center gap-1 text-sm font-medium hover:underline transition-colors"
            >
              {guidance.secondaryAction} <ArrowRight size={14} />
            </button>
            <button
              onClick={handlePrimaryAction}
              className={`inline-flex items-center gap-2 ${getButtonColorClasses(guidance.color)} px-4 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm`}
            >
              {guidance.primaryAction} <ArrowRight size={14} />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserSceneNotification